!function ($, global) {
    'use strict';

    var $window = $(global);
    var body = global.document.body;
    var topPrev = $window.scrollTop();

    var update = function () {
        var top = $window.scrollTop();
        var delta;
        var windowHeight;
        var bottom;

        if (top !== topPrev) {
            delta = top - topPrev;
            windowHeight = global.innerHeight;
            bottom = body.offsetHeight - top - windowHeight;

            if(bottom < 0) {
                bottom = 0;
            }

            $window.trigger('scrolled.om', {
                delta: delta,
                direction: Math.sign(delta),
                top: top,
                window: windowHeight,
                bottom: bottom
            });

            topPrev = top;
        }
    };

    $window.scroll(update).resize(update);
    $(update);

}(jQuery, window);
